/**
 * Created by m.igrachev on 8/4/2017.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/ParagraphItemDocumentedProps";

export default class ParagraphItem extends React.Component {}

ParagraphItem.displayName = "ParagraphItem";
ParagraphItem.propTypes = {
    placeholder: PropTypes.string.isRequired
};
ParagraphItem.documentedProps = documentedProps;
